<template>
  <div class='report-container'>
    <div class="input-item">
      <span>店铺名称</span>
      <input placeholder="请输入店铺名称" v-model="shop">
    </div>
    <div class="input-item">
      <span>店铺地址</span>
      <input placeholder="请输入店铺地址" v-model="shopAddress">
    </div>
    <div class="input-item">
      <span>您的姓名</span>
      <input placeholder="请输入您的姓名" v-model="name">
    </div>
    <div class="input-item">
      <span>联系电话</span>
      <input placeholder="请输入联系电话" v-model="mobile">
    </div>
    <div class="footer">
      <button @click="ignore" class="color-disabled">忽 略</button>
      <button @click="submit">提 交</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import { mapGetters } from 'vuex'

import { Area, Popup, Picker, Toast, Dialog } from 'vant'
import { ImagePreview } from 'vant'

Vue.use(Popup).use(Area).use(Picker).use(Toast)
export default {
  name: 'FleeReport',
  data() {
    return {
      type: 1, // 窜货
      shop: '',
      shopAddress: '',
      name: '',
      mobile: ''
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['location', 'qrcode'])
  },
  methods: {
    /**
     * 忽略
     */
    ignore() {
      this.$emit('ignored')
    },
    submit() {
      if (!this.shop) {
        return Toast('请输入店铺名称')
      }
      if (!this.shopAddress) {
        return Toast('请输入店铺地址')
      }
      if (!this.name) {
        return Toast('请输入您的姓名')
      }
      if (!this.mobile) {
        return Toast('请输入您的手机号')
      }
      var that = this
      var params = {
        shop: this.shop,
        address: this.shopAddress,
        name: this.name,
        mobile: this.mobile,
        location: this.location.address,
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        province: this.location.province,
        city: this.location.city,
        district: this.location.district,
        province_code: this.location.province_code,
        city_code: this.location.city_code,
        district_code: this.location.district_code,
        type: this.type
      }
      if (this.qrcode) {
        params.qrcode = this.qrcode.id
      }
      this.axios.post('/antifake/report/', qs.stringify(params)).then(function(res) {
        if (res.data) {
          Dialog.alert({
            message: '感谢您的反馈，我们会尽快核实，确认信息属实将给您5个积分的奖励'
          }).then(() => {
            that.$emit('submited')
          })
        } else {
          Toast(res.data.msg)
          that.$emit('ignored')
        }
      }).catch(function(error) {
        console.log(error)
        Toast('提交失败')
        that.$emit('ignored')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-container{
  padding-bottom: 65px;
  .input-item{
    height: 44px;
    padding: 0 20px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
    }
    input{
      width: 250px;
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
      text-align: right;
    }
  }
  .textarea-item{
    background-color: #ffffff;
    line-height: 44px;
    margin-bottom: 1px;
    span{
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
    }
    textarea{
      width: 90%;
      height: 80px;
      padding: 5px;
      font-size: 14px;
      border-color: #ffffff;
      color: #4a4a4a;
      resize: none;
      display: block;
      margin: 0 auto;
    }
  }
  .footer{
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .color-disabled {
      background-color: #aaaaaa;
    }
    button{
      width: 120px;
      height: 35px;
      border-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
      border: none;
      margin: 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/fleeReport.vue